const prefix = 'ALUMNI';

export const UPDATE_GRID_FILTER = `${prefix}/UPDATE_GRID_FILTER`;
export const SET_LOADING = `${prefix}/SET_LOADING`;
export const POPULATE_ALUMNI = `${prefix}/POPULATE_ALUMNI`;
export const RESET_FILTERS = `${prefix}/RESET_FILTERS`;
export const POPULATE_CONTEXT = `${prefix}/POPULATE_CONTEXT`;
export const POPULATE_TAGS = `${prefix}/POPULATE_TAGS`;
export const POPULATE_ROSTERS = `${prefix}/POPULATE_ROSTERS`;
export const POPULATE_SURVEYS = `${prefix}/POPULATE_SURVEYS`;
export const POPULATE_ALUMNI_LANDING_PAGE_INFO = `${prefix}/POPULATE_ALUMNI_LANDING_PAGE_INFO`;
export const POPULATE_SEARCHED_HIGH_SCHOOLS = `${prefix}/POPULATE_SEARCHED_HIGH_SCHOOLS`;
export const SET_ACTIVE_USER = `${prefix}/SET_ACTIVE_USER`;
export const SET_LOADING_DETAIL = `${prefix}/SET_LOADING_DETAIL`;
export const POPULATE_ALUM = `${prefix}/POPULATE_ALUM`;
export const POPULATE_OPTION_CONTEXT = `${prefix}/POPULATE_OPTION_CONTEXT`;
export const ADD_ALUM_DETAILS_TO_GRID = `${prefix}/ADD_ALUM_DETAILS_TO_GRID`;
export const SET_ACTIVE_TAB = `${prefix}/SET_ACTIVE_TAB`;
export const POPULATE_SEARCHED_MAJORS = `${prefix}/POPULATE_SEARCHED_MAJORS`;
export const POPULATE_SEARCHED_HE_SCHOOLS = `${prefix}/POPULATE_SEARCHED_HE_SCHOOLS`;
export const POPULATE_SEARCHED_TAGS = `${prefix}/POPULATE_SEARCHED_TAGS`;
export const POPULATE_SEARCHED_ROSTERS = `${prefix}/POPULATE_SEARCHED_ROSTERS`;
export const POPULATE_SEARCHED_SURVEYS = `${prefix}/POPULATE_SEARCHED_SURVEYS`;
export const POPULATE_ANALYTICS_CONTEXT = `${prefix}/POPULATE_ANALYTICS_CONTEXT`;
export const POPULATE_HE_SCHOOL_LIST_ANALYTICS = `${prefix}/POPULATE_HE_SCHOOL_LIST_ANALYTICS`;
export const POPULATE_NSC_INFO = `${prefix}/POPULATE_NSC_INFO`;
export const SET_ALUMNI_DATABASE_HASH = `${prefix}/SET_ALUMNI_DATABASE_HASH`;
